import sessionHelper from "./sessionHelper";
import { Client } from "./_clientService";

async function createPack2(pack: any) {
  try {
    const response = await new Client({
      path: `/player/pack/create`,
      payload: { ...pack, isDisabled: true },
    }).post();

    return response;
  } catch (error) {
    throw error;
  }
}

async function updatePack2(pack: any) {
  try {
    const response = await new Client({
      path: `/player/pack/update`,
      payload: pack,
    }).patch();
    return response;
  } catch (error) {
    console.error("Error creating pack:", error);
    throw error;
  }
}

async function getPackImages(pack: any) {
  try {
    const response = await new Client({
      path: `/player/pack/predefined-images/list`,
    }).get();
    return response;
  } catch (error) {
    throw error;
  }
}

async function updatePack(data: any) {
  let payload = {
    _id: data._id,
    name: data.name,
    type: data.type[0],
    summary: data.summary,
    price: parseFloat(data.price) || 0.0,
    slots: data.slots,
    isFTUPack: data.isFTUPack || false,
  };

  try {
    const response = await new Client({
      path: `/player/pack/update`,
      payload,
    }).patch();
    return response;
  } catch (error) {
    console.error("Error creating pack:", error);
    throw error;
  }
}

async function createPack(data: any) {
  let payload = {
    name: data.packName,
    type: data.packType[0],
    summary: data.packDescription,
    price: parseFloat(data.packPrice) || 0.0,
    slots: data.slots,
    isFTUPack: data.isFTUPack || false,
  };

  try {
    const response = await new Client({
      path: `/player/pack/create`,
      payload,
    }).post();
    return response;
  } catch (error) {
    console.error("Error creating pack:", error);
    throw error;
  }
}

async function getPlayerPacks(options: any) {
  let payload = {
    pageNo: options?.pageNo ?? 1,
    limit: options.pageSize ?? 10,
    sortKey: options.sortBy ?? "updatedAt",
    sortDir: options?.sortDir ?? "DESC",
    search: options?.search ?? "",
    ...(options?.type && { type: options.type }),
    ...(options?.isDisabled !== undefined && { isDisabled: options.isDisabled }),
  };

  let response = await new Client({
    path: "/player/pack/list",
    payload,
  }).post();

  const { items } = response?.data;

  const updatedList = items?.map((el: any) => {
    return {
      ...el,
      summary:
        el?.summary?.length > 25
          ? `${el.summary.substring(0, 25)}...`
          : el.summary,
    };
  });

  let returnData = {
    message: response.message,
    ...response.data,
    items: updatedList,
  };

  return returnData;
}

async function packInfo(packId: any) {
  try {
    let path = "/player/pack/info";
    const response = await new Client({ path, payload: { packId } }).post();
    return response;
  } catch (error) {
    throw error;
  }
}
async function getBoosters(search?: any, pageNo?: any, pageSize?: any) {
  const path = `/boosters/list`;
  const response = await new Client({ path }).get();
  return response;
}

async function getCountries() {
  const path = `/countries/list`;
  const response = await new Client({ path }).get();
  return response;
}

export async function deletePack(packId: any) {
  const resp = await new Client({
    path: `/player/pack/delete`,
    payload: { packId },
  }).post();

  return resp;
}

export async function updatePackStatus(packId: any) {
  const resp = await new Client({
    path: `/player/pack/update/status`,
    payload: { packId },
  }).patch();

  return resp;
}

export async function copyPack(packId: any) {
  const resp = await new Client({
    path: `/player/pack/copy`,
    payload: { packId },
  }).post();

  return resp;
}

export async function validatePackSlots(slots: any, excludePlayers?: any[]) {
  const resp = await new Client({
    path: `/player/pack/validate-slots`,
    payload: { slots, excludePlayers },
  }).post();

  return resp;
}

// ─── Bulk pack upload + pack image library ───────────────────────────────

export async function bulkUploadPacks(file: File) {
  const formData = new FormData();
  formData.append("file", file);

  const resp = await new Client({
    path: `/player/pack/bulk`,
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

export async function downloadPackTemplate() {
  const url = `${import.meta.env.VITE_CMS_API_URL}/player/pack/bulk/template`;

  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${sessionHelper?.token}` },
  });

  if (!response.ok) {
    throw new Error("Failed to download the template. Please try again.");
  }

  const blob = await response.blob();
  const disposition = response.headers.get("Content-Disposition") || "";
  const match = disposition.match(/filename=([^;]+)/);
  const filename = match ? match[1].trim() : `Bulk-Create-Packs-Template.xlsx`;

  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

export async function listPackLibraryImages() {
  const resp = await new Client({ path: `/player/pack/library-images/list` }).get();
  return resp;
}

export async function uploadPackLibraryImagesZip(file: File) {
  const formData = new FormData();
  formData.append("file", file);

  const resp = await new Client({
    path: `/player/pack/library-images/upload`,
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

export async function replacePackLibraryImage(imageId: string, file: File) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("imageId", imageId);

  const resp = await new Client({
    path: `/player/pack/library-images/replace`,
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

export async function deletePackLibraryImage(imageId: string) {
  const resp = await new Client({
    path: `/player/pack/library-images/delete`,
    payload: { imageId },
  }).post();
  return resp;
}

export {
  createPack2,
  updatePack2,
  getPackImages,
  createPack,
  getPlayerPacks,
  getBoosters,
  getCountries,
  updatePack,
  packInfo,
};
